import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import { selectProject, fetchProjectUsers, fixContacts } from '../../actions'
import { Roles } from '../../config'
import Loading from '../Loading'
import Dashboard from '../Dashboard/Dashboard'
import Contacts from '../Contacts/Contacts'
import Appointments from '../Appointments'

import { Button, Tabs, Icon } from 'antd'
const TabPane = Tabs.TabPane

class Project extends Component {
  state = {
    showFixContactsButton: false // show DB helper function button
  }

  componentDidMount = () => {
    const { match: { params }, fetchProjectUsers } = this.props

    fetchProjectUsers(params.projectId)
  }

  handleFixContacts = () => {
    const { match: { params }, fixContacts } = this.props

    fixContacts(params.projectId)
  }

  render () {
    const { t, match: { params }, user /* selectProject */ } = this.props

    if (!user) {
      return <p>You need to be logged in to see the project</p>
    }

    // wait for user data from Firebase AND for user.projectsRoles (collected in fetchProjects())
    if (!user.projectsRoles) return <Loading />

    const myProjectRole = user.projectsRoles[params.projectId]

    return (
      <div>
        {process.env.NODE_ENV !== 'production' &&
          <span>
            <span className='testing' style={{ position: 'absolute', right: 0, marginRight: 20 }}>{myProjectRole}</span>
          </span>}

        {this.state.showFixContactsButton &&
          <Button type='danger' onClick={() => this.handleFixContacts()} style={{ marginBottom: 20 }}>
            fixContacts()
          </Button>}

        {/* quick Project edit */}
        {/* {myProjectRole < Roles.PROJECT.CLIENT &&
          <Button icon='edit' type='primary' onClick={() => selectProject('edit', params.projectId)} />} */}

        {/* if I am superadmin/project manager */}
        {myProjectRole < Roles.PROJECT.AGENT &&
          <Link to={`/project/${params.projectId}/settings`}>
            <Button icon='setting' type='primary' style={{ position: 'absolute', right: 40, zIndex: 1 }}>
              {t('project.settings')}
            </Button>
          </Link>}

        <Tabs type='card'>

          {/* admins/agent/client */}
          {myProjectRole < Roles.PROJECT.SALESPERSON &&
            <TabPane tab={<span><Icon type='contacts' />Contacts</span>} key='0'>
              <Dashboard role={myProjectRole} />
              {myProjectRole < Roles.PROJECT.CLIENT && <Contacts />}
            </TabPane>}

          {/* all roles */}
          <TabPane tab={<span><Icon type='calendar' />Appointments</span>} key='1'>
            <Appointments role={myProjectRole} />
          </TabPane>

        </Tabs>
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user,
  projects: state.projects
})

const mapDispatchToProps = {
  selectProject,
  fetchProjectUsers,
  fixContacts
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(translate('translations')(Project)))



// WEBPACK FOOTER //
// ./src/components/Projects/Project.js